import { sha256 } from "js-sha256";
import api from "@/services/api2.service";
import { Constants } from "@/cfg/constants";

class AuthService {
  userMe(token) {
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return api.get("/user/me", { headers });
  }

  vanillaLogin(user) {
    return api.post("/user-login", user);
  }

  updateProfile(user) {
    return api.patch("/user", user);
  }

  vanillaRegister(user) {
    let userData = {
      ...user,
      ...this.appendSaltedFields(),
    };

    if (!userData.language) {
      userData.language = Constants.DEFAULT_LANGUAGE;
    }

    return api.post("/user-registration", userData);
  }

  googleLogin(googleResponse) {
    return api.post("/user-login-google", {
      id_token: googleResponse.access_token,
      token_type: "access_token",
    });
  }

  appleLogin(appleResponse) {
    const appleAuth = appleResponse.authorization;
    const appleUser = appleResponse.user;

    let loginObject = {
      id_token: appleAuth.id_token,
      token_type: "id_token",
    };

    if (appleUser) {
      loginObject.name =
        appleUser.name.firstName + appleUser.name.lastName
          ? " " + appleUser.name.lastName
          : "";
    }

    console.log(loginObject);

    return api.post("/user-login-apple", loginObject);
  }

  saveCampaignData(params) {
    console.log("Payload being sent to API: ", params);
    return this.setUserAttribute(params).then(
      (response) => {
        console.log("Raw API Response: ", response);
        return Promise.resolve(response.data);
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  }

  setUserAttribute(params) {
    return api.post("/user/attribute", params);
  }

  resend(params) {
    return api.post("/user-resend-confirmation-code", params);
  }

  resetPassword(params) {
    return api.post("/user-reset-password", params).then(
      (response) => {
        return Promise.resolve(response.data);
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  }

  resetPasswordVerifyCode(email, code) {
    console.log("Payload being sent to API for token: ", { email, code });
    return api.post("/user-reset-password-verify-code", { email, code }).then(
      (response) => {
        console.log("Token created"); // can add more if needed
        return Promise.resolve(response.data);
      },
      (error) => {
        console.log("Error in the API call: ", error);
        if (error.response) {
          console.error("Error Response Data: ", error.response.data);
        }
        return Promise.reject(error);
      },
    );
  }

  setNewPassword(params) {
    //console.log("Payload being sent to the API for setNewPassword: ", params);
    return api.post("/user/password/new-password", params).then(
      (response) => {
        console.log("Password reset successfully");
        return Promise.resolve(response.data);
      },
      (error) => {
        console.error("Error in the API call: ", error);
        if (error.response) {
          console.error("Error Response Data: ", error.response.data);
        }
        return Promise.reject(error);
      },
    );
  }

  confirmAccount(code, token, email) {
    return api.post("/user/email-verify", {
      token: token,
      code: code,
      email: email,
    });
  }

  deleteAccount() {
    return api.post("/user/deactivate/account");
  }

  markForDeletion(email) {
    const payload = {
      corrections: {
        email,
      },
      justification: "User is requesting account deletion.",
    };

    return api.patch("/privacy/data-rectification", payload, {
      headers: {
        "Content-Type": "application/json",
      },
      transformRequest: [(data) => JSON.stringify(data)],
    });
  }

  appendSaltedFields() {
    let udid = this.generateUDID();
    // TODO think about another implementation of this
    const SALT = "AA:EA:A7:AD:3D:F0:15:03:36:80:ED:00:6C:B1:AF:77:84:50:C6:3C";
    let api_key = sha256(udid + "web" + SALT);

    return {
      udid: udid,
      api_key: api_key,
    };
  }

  generateUDID() {
    return sha256("web" + new Date().getTime());
  }
}
export default new AuthService();
